import { createContext } from 'react';
import { usePrivanaI18n } from './PrivanaI18nProvider.jsx';
// Opt-in only for the standalone surfaces. A modal needs its own reachable
// control because its focus trap makes the underlying header unavailable.
export const SurfaceDialogLanguageContext = createContext(null);
export default function SurfaceDialogLanguage({ children, control }) {
  const { t } = usePrivanaI18n();
  return <SurfaceDialogLanguageContext.Provider value={{ control, closeLabel: t('surfaceLanguage.close') }}>{children}</SurfaceDialogLanguageContext.Provider>;
}
